"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyServiceStub = void 0;
const mystake_common_sdk_1 = require("@redbelly-tokeniser/mystake-common-sdk");
const mystake_validator_public_1 = require("@redbelly-tokeniser/mystake-validator-public");
const faker = __importStar(require("faker"));
const moment_1 = __importDefault(require("moment"));
const IVaultSetup_1 = require("../contracts/IVaultSetup");
const OptionGrantType_1 = require("../contracts/options/OptionGrantType");
const enums_1 = require("../enums");
const fakeCompanyInfo = {
    _id: faker.random.uuid(),
    name: faker.fake("{{company.companyName}} {{company.companySuffix}}"),
    acn: faker.random.number().toString(),
    abn: faker.random.number().toString(),
    tfn: faker.random.number().toString(),
    registeredAddress: faker.random.uuid(),
    principalPlaceOfBusinessAddress: faker.random.uuid(),
    companyType: faker.random.arrayElement(),
    shareholderType: faker.random.arrayElement(),
    tncAccepted: faker.random.boolean(),
    kycAuthorization: {
        hasNominated: faker.random.boolean(),
        nomineeId: faker.random.uuid(),
        dateOfNomination: faker.date.recent(),
        nomineeToken: faker.random.alphaNumeric(),
    },
    status: [
        mystake_common_sdk_1.CompanyListItemStatus.ReadyForReview,
        mystake_common_sdk_1.CompanyListItemStatus.KYCPending,
        mystake_common_sdk_1.CompanyListItemStatus.SetUpInProgress,
        mystake_common_sdk_1.CompanyListItemStatus.AddPaymentMethod,
    ][faker.random.number({ min: 0, max: 3 })],
    stripeData: {
        customerId: faker.random.uuid(),
        selectedPriceId: faker.random.uuid(),
        subscriptionId: faker.random.uuid(),
        selectedSubscriptionPlan: faker.random.word(),
    },
    isAsicConnectionActivated: faker.random.boolean(),
    primaryAdminId: faker.random.uuid(),
    displayName: "",
    displayLogo: "",
    shareCertificateConfig: {
        enableShareCertificates: true,
        prefix: "ABC",
        startNumber: 10,
        officeholders: [{ _id: faker.random.uuid(), fontFamily: null }],
    },
    shareTokenisationStandard: mystake_common_sdk_1.ShareTokenisationStandard.Legacy,
};
const fakeUserProfile = {
    _id: faker.random.uuid(),
    salutation: faker.name.prefix(),
    familyName: faker.name.lastName(),
    firstName: faker.name.lastName(),
    emails: [
        {
            email: faker.internet.email(),
            isPrimary: faker.random.boolean(),
            isVerified: faker.random.boolean(),
        },
    ],
    phones: [
        {
            iso2: faker.address.countryCode(),
            dialCode: faker.phone.phoneNumber(),
            phoneNumber: faker.phone.phoneNumber(),
            isPrimary: faker.random.boolean(),
            isVerified: faker.random.boolean(),
        },
    ],
    username: faker.random.uuid(),
    birthDetails: {
        dob: faker.date.past(20),
        birthPlace: faker.address.city(),
        birthCountry: faker.address.country(),
    },
    kycDetails: {
        isKYCDone: faker.random.boolean(),
        address: {
            // flatNumber: faker.address.secondaryAddress(),
            description: "987/12345 Street St, Qld, AU",
            flatNumber: "987",
            streetNumber: "12345",
            streetName: faker.address.streetName(),
            suburb: faker.address.city(),
            postcode: faker.address.zipCode(),
            // state: faker.address.state(),
            state: "QLD",
            // country: faker.address.country(),
            country: "AU",
        },
        verificationId: "",
        verificationToken: "",
    },
    companyIds: faker.random.boolean() ? [faker.random.uuid()] : [faker.random.uuid(), faker.random.uuid()],
    onboardingStatus: [
        mystake_common_sdk_1.CompanyListItemStatus.ReadyForReview,
        mystake_common_sdk_1.CompanyListItemStatus.KYCPending,
        mystake_common_sdk_1.CompanyListItemStatus.SetUpInProgress,
        mystake_common_sdk_1.CompanyListItemStatus.AddPaymentMethod,
    ][faker.random.number({ min: 0, max: 3 })],
    isInvestor: faker.random.boolean(),
    isExternalInvestor: faker.random.boolean(),
    roles: [mystake_common_sdk_1.Roles.ADMIN],
    rolesByCompany: [
        {
            companyId: faker.random.uuid(),
            roles: [mystake_common_sdk_1.Roles.ADMIN],
        },
    ],
};
const fakeAddress = {
    careOf: faker.name.firstName(),
    line2: faker.random.alphaNumeric(),
    street: faker.address.streetName(),
    locality: faker.address.city(),
    state: faker.address.stateAbbr(),
    postcode: faker.address.zipCode(),
    country: faker.address.country(),
};
function generateFakeShareholder() {
    return {
        _id: faker.random.alphaNumeric(20),
        shareholderIdentificationNumber: faker.random.alphaNumeric(12),
        entityType: Object.values(mystake_validator_public_1.EntityType)[faker.random.number({ min: 0, max: 3 })],
        trusteeType: Object.values(mystake_validator_public_1.TrusteeType)[faker.random.number({ min: 0, max: 3 })],
        legalEntityName: `${faker.name.prefix()} ${faker.name.firstName()} ${faker.name.lastName()}`,
        shares: faker.random.number(),
        stake: faker.random.number(),
        totalPaid: faker.random.number(),
        fullyPaid: faker.random.boolean() ? "Yes" : "No",
        dateFirstEntry: faker.date.past().toISOString(),
    };
}
function generateFakeNotesData() {
    return {
        type: ["convertible", "safe", "custom"][faker.random.number({ min: 0, max: 2 })],
        name: faker.random.alphaNumeric(),
        faceValue: faker.random.number({ min: 0, max: 1000000 }),
        code: faker.random.word(),
        _id: faker.random.uuid(),
        amountIssued: faker.random.number(),
        status: ["issue", "converted", "paid"][faker.random.number({ min: 0, max: 2 })],
    };
}
function generateFakeFundraiseData() {
    const index = faker.random.number({ min: 0, max: 1 });
    return [
        {
            _id: faker.random.uuid(),
            shareClassCode: ["ORD", "PREF"][index],
            shareClassName: ["ORDINARY", "PREFERRED"][index],
            name: faker.random.alphaNumeric(),
            fundraiseCode: faker.random.word(),
            goal: faker.random.number({ min: 0, max: 1000000 }),
            offered: faker.random.number({ min: 0, max: 7000000 }),
            issued: faker.random.number({ min: 0, max: 9000000 }),
            openDate: faker.date.past(10).toISOString(),
            customerAccountName: faker.random.word(),
            customerAccountBSB: faker.random.alphaNumeric(6),
            customerAccountNumber: faker.random.alphaNumeric(12),
        },
    ];
}
function generateFakeHoldings() {
    const index = faker.random.number({ min: 0, max: 1 });
    return [
        {
            shareClass: ["ORDINARY", "PREFERRED"][index],
            shareClassCode: ["ORD", "PREF"][index],
            shareClassId: ["shareclass-5f9b1b1b1b1b1b1b1b1b1b1b", "shareclass-6f9b1b1b1b1b1b1b1b1b1b1b"][index],
            shares: faker.random.number(),
            stake: faker.random.number(),
            pricePerShare: faker.random.number(),
            currentValue: faker.random.number(),
        },
    ];
}
function generateFakeCompanyTransactions() {
    const index = faker.random.number({ min: 0, max: 1 });
    const transaction = {
        _id: faker.random.uuid(),
        date: faker.date.past(),
        shares: faker.random.number(),
        beneficialOwner: faker.random.boolean(),
        isTrustOrSMSF: faker.random.boolean(),
        pricePerShare: faker.random.number(),
        investorType: [mystake_validator_public_1.InvestorType.SOPHISTICATED, mystake_validator_public_1.InvestorType.CROWD_SOURCED][index],
        acn: `${faker.random.number({ min: 111111111, max: 999999999 })}`,
        totalPaid: faker.random.number(),
        name: faker.name.firstName().toString(),
        shareClassCode: ["ORD", "PREF"][index],
        type: ["Buy", "Sell"][index],
        shareClass: ["ORDINARY", "PREFERRED"][index],
        totalUnPaid: faker.random.number(),
        address: [],
        owners: [
            {
                address: { ...fakeAddress },
            },
        ],
        taxFileNumber: "111 111 111",
        shareholderId: faker.random.alphaNumeric(20),
        contacts: [
            {
                _id: faker.random.alphaNumeric(20),
                userId: faker.random.alphaNumeric(20),
                firstName: faker.name.firstName(),
                secondName: faker.name.firstName(),
                thirdName: "",
                familyName: faker.name.lastName(),
                email: faker.internet.email(),
                lastLogin: new Date(),
                invitationSentDate: new Date(),
                iso2Code: "",
                dialCode: "",
                phoneNumber: "",
            },
        ],
    };
    return transaction;
}
function generateFakeTransactions() {
    const index = faker.random.number({ min: 0, max: 1 });
    return {
        date: faker.date.past(),
        type: ["WHOLESALE", "RETAIL", "CSF", "OTHER"][faker.random.number({ min: 0, max: 3 })],
        shareClass: ["ORDINARY", "PREFERRED"][index],
        shareClassCode: ["ORD", "PREF"][index],
        shares: faker.random.number(),
        pricePerShare: faker.random.number({ min: 1, max: 100 }),
        totalPaid: faker.random.number(),
        totalUnPaid: faker.random.number(),
    };
}
function generateFakeInvestorDetails() {
    return {
        _id: faker.random.alphaNumeric(20),
        entityType: Object.values(mystake_validator_public_1.EntityType)[faker.random.number({ min: 0, max: 3 })],
        trusteeType: Object.values(mystake_validator_public_1.TrusteeType)[faker.random.number({ min: 0, max: 3 })],
        contactPersonCount: 1,
        legalEntityName: `${faker.name.prefix()} ${faker.name.firstName()} ${faker.name.lastName()}`,
        contact: {
            _id: faker.random.alphaNumeric(20),
            userId: faker.random.alphaNumeric(20),
            firstName: faker.name.firstName(),
            secondName: faker.name.firstName(),
            thirdName: "",
            familyName: faker.name.lastName(),
            email: faker.internet.email(),
        },
        lastLogin: faker.date.past(),
    };
}
function generateFakeContactDetails() {
    return {
        _id: faker.random.alphaNumeric(20),
        entityType: Object.values(mystake_validator_public_1.EntityType)[faker.random.number({ min: 0, max: 3 })],
        trusteeType: Object.values(mystake_validator_public_1.TrusteeType)[faker.random.number({ min: 0, max: 3 })],
        contactPersonCount: 1,
        legalEntityName: `${faker.name.prefix()} ${faker.name.firstName()} ${faker.name.lastName()}`,
        contact: {
            _id: faker.random.alphaNumeric(20),
            userId: faker.random.alphaNumeric(20),
            firstName: faker.name.firstName(),
            secondName: faker.name.firstName(),
            thirdName: "",
            familyName: faker.name.lastName(),
            email: faker.internet.email(),
            phone: {
                dialCode: "+91",
                phoneNumber: "9999999999",
            },
        },
        name: `${faker.name.prefix()}${faker.name.firstName()}${faker.name.lastName()}`,
    };
}
function generateEntityData() {
    return {
        email: faker.internet.email(),
        address: `${faker.address.streetName()} ${faker.address.city()} ${faker.address.county()}`,
        phoneNumber: faker.phone.phoneNumber(),
        dateOfFirstEntry: faker.date.past().toISOString(),
    };
}
function generateIndividualShareholder() {
    return {
        name: `${faker.name.prefix()} ${faker.name.firstName()} ${faker.name.lastName()}`,
        ...generateEntityData(),
    };
}
function generateIndividualTrustee() {
    return {
        contact: `${faker.name.prefix()} ${faker.name.firstName()} ${faker.name.lastName()}`,
        ...generateEntityData(),
    };
}
const stubTrustee = (companyId, shareholderId) => ({
    _id: "trustees-1",
    companyId,
    shareholderId,
    trusteeType: mystake_validator_public_1.TrusteeType.INDIVIDUAL,
    firstName: "Jane",
    lastName: "Doe",
    email: "jane.doe@example.com",
});
class CompanyServiceStub {
    constructor() {
        this.accrualSettings = {};
        this.accrualRates = {};
    }
    async addPaymentMethod(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    companyId, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    nameOnCard, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    cardNumber, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    expiry, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    cvv, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isPlanPaid) {
        return faker.random.boolean()
            ? {
                status: true,
                message: "Successfully added payment method",
                payload: null,
            }
            : {
                status: false,
                message: "Failed to add payment method",
                payload: null,
            };
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async addCompany(companyData) {
        // Prefill data
        return {
            status: true,
            message: "Company successfully created",
            payload: null,
        };
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async setSelectedPlan(companyId, selectedPlanId) {
        return {
            status: true,
            message: "Successfully added payment method",
            payload: null,
        };
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async cancelCompanyCreation(companyId) {
        return {
            status: true,
            message: "Company removed successfully",
            payload: null,
        };
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async updateLastAccess(companyId) {
        return {
            status: true,
            message: "Company last access successfully updated",
            payload: null,
        };
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async getCompanies(search = "", active = false) {
        const resultCount = faker.random.number({ min: 2, max: 5 });
        const data = [];
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < resultCount; i++) {
            data.push({
                name: faker.company.companyName(),
                acn: `${faker.random.number({ min: 111111111, max: 999999999 })}`,
                status: [
                    mystake_common_sdk_1.CompanyListItemStatus.ReadyForReview,
                    mystake_common_sdk_1.CompanyListItemStatus.KYCPending,
                    mystake_common_sdk_1.CompanyListItemStatus.SetUpInProgress,
                    mystake_common_sdk_1.CompanyListItemStatus.AddPaymentMethod,
                ][faker.random.number({ min: 0, max: 3 })],
                companyId: faker.random.alphaNumeric(16),
                lastAccessed: (0, moment_1.default)(faker.date.past()).format("DD/MM/YYYY"),
            });
        }
        return {
            status: true,
            payload: data,
            message: "",
        };
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async getCompanyInfo(companyId) {
        return faker.random.boolean()
            ? Promise.resolve({
                status: true,
                message: "",
                payload: fakeCompanyInfo,
            })
            : // eslint-disable-next-line prefer-promise-reject-errors
                Promise.reject({
                    status: false,
                    message: "Company not found",
                    payload: null,
                });
    }
    async getCompanyByAcn(acn) {
        if (acn) {
            return {
                status: true,
                message: "",
                payload: fakeCompanyInfo._id,
            };
        }
        return {
            status: false,
            message: "Company not found",
            payload: null,
        };
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async getAdminInfo(companyId) {
        return faker.random.boolean()
            ? Promise.resolve({
                status: true,
                message: "",
                payload: fakeUserProfile,
            })
            : // eslint-disable-next-line prefer-promise-reject-errors
                Promise.reject({
                    status: false,
                    message: "Admin not found",
                    payload: null,
                });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async updateAuthorizer(companyId, nomineeRequest) {
        return faker.random.boolean()
            ? Promise.resolve({
                status: true,
                message: "Successfully Nominated for KYC",
                payload: null,
            })
            : // eslint-disable-next-line prefer-promise-reject-errors
                Promise.reject({
                    status: false,
                    message: "Failed to nominate for KYC",
                });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async unsetKYCAuthorizationDetails(companyId) {
        return faker.random.boolean()
            ? Promise.resolve({
                status: true,
                message: "Successfully unset kyc authorization details",
                payload: null,
            })
            : // eslint-disable-next-line prefer-promise-reject-errors
                Promise.reject({
                    status: false,
                    message: "Failed to unset kyc authorization details",
                });
    }
    async updateCompanyAuthorizationDetails(updateCompanyAuthorizationDetailsBody) {
        if (updateCompanyAuthorizationDetailsBody) {
            return {
                status: true,
                payload: null,
                message: "company status changed",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Error changing company authorization",
        };
    }
    async getAllTransactions(companyId) {
        if (companyId) {
            const transactions = Array.from({
                length: 30,
            }).map(() => generateFakeCompanyTransactions());
            return {
                status: true,
                payload: transactions,
                message: "",
            };
        }
        return {
            status: false,
            payload: null,
            message: "",
        };
    }
    async getShareholderBankDetails(companyId) {
        if (companyId) {
            return {
                status: true,
                payload: [{ name: "Acme Pty Ltd", bsb: "123-456", accountNumber: "12345678", accountName: "Acme Pty Ltd" }],
                message: "",
            };
        }
        return {
            status: false,
            payload: null,
            message: "",
        };
    }
    async getFatcaCrsExport(companyId) {
        return {
            status: !!companyId,
            payload: { columns: ["Row Type", "Investor", "Name"], rows: [] },
            message: "",
        };
    }
    async getCompanyRegister(companyId, keyword, activeClassId, page, rowsPerPage, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sortBy, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sortOrder) {
        const count = faker.random.number({ min: 150, max: 280 });
        const tabCount = faker.random.number({ min: 1, max: 2 });
        const data = [];
        for (let i = 0; i < (rowsPerPage < count ? rowsPerPage : count); i += 1) {
            data.push(generateFakeShareholder());
        }
        return {
            status: false,
            payload: {
                classes: tabCount === 1
                    ? [
                        {
                            _id: faker.random.uuid(),
                            name: "Oridinary",
                            shareClassCode: "ORD",
                        },
                    ]
                    : [
                        {
                            _id: faker.random.uuid(),
                            name: "Oridinary",
                            shareClassCode: "ORD",
                        },
                        {
                            _id: faker.random.uuid(),
                            name: "Preferred",
                            shareClassCode: "PREF",
                        },
                    ],
                count,
                data,
            },
            message: "",
        };
    }
    async getShareholderDetails(companyId, shareholderId, entityType, trusteeType) {
        if (shareholderId && companyId) {
            const shareHolding = {
                entityDetail: {
                    entityType,
                    entities: [],
                },
                holdings: generateFakeHoldings(),
                transactions: Array.from({
                    length: 5,
                }).map(() => generateFakeTransactions()),
                transactionCount: faker.random.number(1000),
                notesTransactions: [generateFakeNotesData()],
            };
            if (entityType === mystake_validator_public_1.EntityType.JOINT) {
                shareHolding.entityDetail.entities = Array.from({
                    length: 3,
                }).map(() => generateIndividualShareholder());
            }
            else if (entityType === mystake_validator_public_1.EntityType.COMPANY) {
                shareHolding.entityDetail = {
                    legalEntityName: faker.name.title(),
                    entityType,
                    entities: [
                        {
                            acn: faker.random.number().toString(),
                            contact: `${faker.name.firstName()} ${faker.name.lastName()}`,
                            ...generateEntityData(),
                        },
                    ],
                };
            }
            else if (entityType === mystake_validator_public_1.EntityType.TRUST || entityType === mystake_validator_public_1.EntityType.SMSF) {
                if (trusteeType === mystake_validator_public_1.TrusteeType.COMPANY) {
                    shareHolding.entityDetail = {
                        legalEntityName: faker.name.title(),
                        entityType,
                        entities: [
                            {
                                trustAbn: faker.random.number().toString(),
                                trusteeAcn: faker.random.number().toString(),
                                contact: `${faker.name.firstName()} ${faker.name.lastName()}`,
                                ...generateEntityData(),
                            },
                        ],
                    };
                }
                else if (trusteeType === mystake_validator_public_1.TrusteeType.INDIVIDUAL) {
                    shareHolding.entityDetail = {
                        legalEntityName: faker.name.title(),
                        entityType,
                        entities: Array.from({
                            length: 3,
                        }).map(() => generateIndividualTrustee()),
                    };
                }
            }
            else {
                shareHolding.entityDetail.entities = Array.from({
                    length: 1,
                }).map(() => generateIndividualShareholder());
            }
            return {
                status: true,
                payload: shareHolding,
                message: "",
            };
        }
        return {
            status: false,
            payload: null,
            message: "",
        };
    }
    async getAllTransactionsByShareholderId(companyId, shareholderId, sortBy, sortOrder) {
        if (companyId && shareholderId && sortBy && sortOrder) {
            const transactions = Array.from({
                length: 30,
            }).map(() => generateFakeTransactions());
            return {
                status: true,
                payload: transactions,
                message: "",
            };
        }
        return {
            status: false,
            payload: null,
            message: "",
        };
    }
    async getUnitIssueStatement(companyId, shareholderId, transactionId, _) {
        if (companyId && shareholderId && transactionId) {
            return {
                status: true,
                payload: Buffer.from("stub-unit-issue-notice").toString("base64"),
                message: "",
            };
        }
        return {
            status: false,
            payload: null,
            message: "",
        };
    }
    async getShareholderTransactionsByAuctionId({ companyId, shareholderId, auctionId, sortBy, sortOrder, page, rowsPerPage, }) {
        if (companyId && shareholderId && auctionId && sortBy && sortOrder && page && rowsPerPage) {
            const transactions = Array.from({
                length: 30,
            }).map(() => generateFakeTransactions());
            return {
                status: true,
                payload: { transactions, count: 30 },
                message: "",
            };
        }
        return {
            status: false,
            payload: null,
            message: "",
        };
    }
    async issueSharesToNewShareholder(companyId, shareholder) {
        if (shareholder && companyId) {
            return {
                status: true,
                payload: { shareholderId: faker.random.uuid() },
                message: "Successfully added shareholder",
            };
        }
        return {
            status: false,
            payload: null,
            message: "",
        };
    }
    async createInvestorProfile(companyId, shareholder) {
        if (shareholder && companyId) {
            return {
                status: true,
                payload: { shareholderId: faker.random.uuid() },
                message: "Successfully created investor profile",
            };
        }
        return {
            status: false,
            payload: null,
            message: "",
        };
    }
    async getInvestorProfileDraft(companyId) {
        return {
            status: Boolean(companyId),
            payload: null,
            message: "",
        };
    }
    async saveInvestorProfileDraft(companyId, draft) {
        return {
            status: Boolean(companyId && draft),
            payload: draft,
            message: "",
        };
    }
    async clearInvestorProfileDraft(companyId) {
        return {
            status: Boolean(companyId),
            payload: null,
            message: "",
        };
    }
    async updateInvestorProfile(companyId, shareholder, overrides) {
        if (companyId && shareholder && overrides) {
            return {
                status: true,
                payload: { shareholderId: faker.random.uuid() },
                message: "Successfully updated investor profile",
            };
        }
        return {
            status: false,
            payload: null,
            message: "",
        };
    }
    async cloneInvestorRequests(targetCompanyId, investors) {
        if (targetCompanyId && investors) {
            return {
                status: true,
                payload: null,
                message: "Successfully cloned investor requests",
            };
        }
        return {
            status: false,
            payload: null,
            message: "",
        };
    }
    async updateShareholder(companyId, shareholderId, shareholder) {
        if (shareholder && companyId && shareholderId) {
            return {
                status: true,
                payload: null,
                message: "Successfully updated shareholder",
            };
        }
        return {
            status: false,
            payload: null,
            message: "",
        };
    }
    async transferSharesToExistingShareholder(companyId, fromShareholderId, toShareholderId, payload) {
        if (companyId && fromShareholderId && toShareholderId && payload?.transaction) {
            return {
                status: true,
                payload: null,
                message: "",
            };
        }
        return {
            status: false,
            payload: null,
            message: "",
        };
    }
    async transferSharesToNewShareholder(companyId, fromShareholderId, shareholder) {
        if (companyId && fromShareholderId && shareholder) {
            return {
                status: true,
                payload: null,
                message: "",
            };
        }
        return {
            status: false,
            payload: null,
            message: "",
        };
    }
    async getSharePriceHistory(companyId, sortBy, sortOrder, filterByShareClass) {
        if (companyId && sortBy && sortOrder && filterByShareClass) {
            const shareClasses = [
                {
                    shareClassId: faker.random.uuid(),
                    name: "ORDINARY",
                    shareClassCode: "ORD",
                },
                {
                    shareClassId: faker.random.uuid(),
                    name: "PREFERRED",
                    shareClassCode: "PREF",
                },
                { shareClassId: faker.random.uuid(), name: "A", shareClassCode: "A" },
                { shareClassId: faker.random.uuid(), name: "B", shareClassCode: "B" },
                { shareClassId: faker.random.uuid(), name: "C", shareClassCode: "C" },
            ];
            const sharePriceLogs = [];
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < shareClasses.length * faker.random.number(20); i++) {
                sharePriceLogs.push({
                    _id: faker.random.uuid(),
                    dateOfUpdate: faker.date.recent(300),
                    shareClass: shareClasses[faker.random.number(4)],
                    sharePrice: faker.random.number(),
                    subscriptionPrice: faker.random.number(),
                    redemptionPrice: faker.random.number(),
                    actionedByUser: {
                        userId: faker.random.uuid(),
                        firstName: faker.random.word(),
                        familyName: faker.random.word(),
                        secondName: faker.random.word(),
                        thirdName: faker.random.word(),
                    },
                });
            }
            return {
                status: true,
                message: "Share Price History",
                payload: { shareClasses, sharePriceLogs },
            };
        }
        return {
            status: false,
            message: "Invalid request",
            payload: null,
        };
    }
    async createNewShareClass(companyId, createNewShareClassData) {
        if (companyId && createNewShareClassData) {
            return {
                status: true,
                payload: null,
                message: "New share class created successfully",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Error creating new share class",
        };
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async getShareStructure(companyId) {
        const data = [];
        const shareClassIndex = faker.random.number({ min: 0, max: 1 });
        const shareClassStructure = {
            shareClassId: faker.random.alphaNumeric(8),
            shareClassName: ["Ordinary", "Preferred"][shareClassIndex],
            shareClassCode: ["Ord", "Pref"][shareClassIndex],
            pricePerShare: faker.random.number({ min: 100, max: 10000 }),
            subscriptionPrice: faker.random.number({ min: 100, max: 10000 }),
            redemptionPrice: faker.random.number({ min: 100, max: 10000 }),
            shareQuantity: faker.random.number({ min: 1000, max: 10000 }),
            sharesValue: 0,
            effectiveFrom: (0, moment_1.default)(faker.date.recent(faker.random.number({ min: 1, max: 27 }))).toDate(),
        };
        shareClassStructure.sharesValue = shareClassStructure.pricePerShare * shareClassStructure.shareQuantity;
        data.push(shareClassStructure);
        return faker.random.boolean()
            ? Promise.resolve({
                status: true,
                message: "",
                payload: data,
            })
            : // eslint-disable-next-line prefer-promise-reject-errors
                Promise.reject({
                    status: false,
                    message: "Unable to fetch share class structure",
                    payload: null,
                });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async isCapitalStructureAndRegisterDifferent(companyId) {
        return faker.random.boolean();
    }
    async getShareCapitalStructure(companyId) {
        if (companyId) {
            const companyRegister = {
                shareClassTitle: faker.random.alphaNumeric(5),
                shareClassCode: faker.random.alphaNumeric(4),
                totalSharesIssued: faker.random.number(5),
                totalAmountPaid: faker.random.number(5),
                totalAmountUnpaid: faker.random.number(5),
            };
            return {
                status: true,
                payload: [companyRegister],
                message: "Success",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Failed",
        };
    }
    async getCapitalStructureAndRegisterDifference(companyId) {
        if (companyId) {
            const shareClassAggregate = {
                shareClassTitle: faker.random.alphaNumeric(5),
                shareClassCode: faker.random.alphaNumeric(4),
                totalSharesIssued: faker.random.number(5),
                totalAmountPaid: faker.random.number(5),
                totalAmountUnpaid: faker.random.number(5),
            };
            const result = {
                isCapitalStructureDifferent: faker.random.boolean(),
                capitalStructure: [
                    {
                        ...shareClassAggregate,
                    },
                ],
                companyRegister: [{ ...shareClassAggregate, match: faker.random.boolean() }],
                dateDataFetched: faker.date.past(),
            };
            return {
                status: true,
                payload: result,
                message: "Success",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Failed",
        };
    }
    async setSharePrice(companyId, shareClassId, setSharePriceRequestBody) {
        if (companyId && shareClassId && setSharePriceRequestBody) {
            return {
                status: true,
                payload: null,
                message: "Share price updated successfully",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Failed to set the share price",
        };
    }
    async getYieldConfig(companyId, shareClassId) {
        const settings = this.accrualSettings[companyId];
        const payload = shareClassId && settings?.accrues
            ? {
                accrues: true,
                accrualStartDate: settings.accrualStartDate,
                accrualStartDayOrdinal: settings.accrualStartDayOrdinal,
                unitPriceCents: 100,
                unitsAccruedToDate: "0.000000",
            }
            : { accrues: false };
        return { status: true, message: "Yield configuration retrieved", payload };
    }
    async getAccrualRates(companyId, shareClassId, asAt) {
        const register = this.accrualRates[`${companyId}:${shareClassId}`] ?? { current: null, scheduled: [], history: [] };
        return {
            status: true,
            message: "Rate register retrieved",
            payload: asAt ? { current: register.current } : register,
        };
    }
    async appendAccrualRate(companyId, shareClassId, rate) {
        const entry = {
            ...rate,
            dayCountBasis: this.accrualSettings[companyId]?.dayCountBasis ?? mystake_common_sdk_1.DayCountBasis.ACTUAL_ACTUAL,
            effectiveDayOrdinal: Date.parse(`${rate.effectiveFrom}T00:00:00Z`) / 86400000,
            approvalState: "executed",
        };
        const register = this.accrualRates[`${companyId}:${shareClassId}`] ?? { current: null, scheduled: [], history: [] };
        const saved = { ...register, current: entry, history: [entry, ...(register.history ?? [])] };
        this.accrualRates[`${companyId}:${shareClassId}`] = saved;
        return { status: true, message: "Rate recorded", payload: saved };
    }
    async getAccrualRuns(companyId, shareClassId) {
        return {
            status: true,
            message: "Accrual runs retrieved",
            payload: companyId && shareClassId ? { runs: [], lastSucceededOn: null } : null,
        };
    }
    async getPendingAccrualMints(companyId) {
        return {
            status: true,
            message: "Pending accrued units retrieved",
            payload: companyId ? { count: 0, classes: [], chainChecked: false } : null,
        };
    }
    async claimAccrualMint(companyId, shareClassId, wallet) {
        return {
            status: true,
            message: "Mint claimed",
            payload: companyId && shareClassId && wallet ? { claimId: faker.random.uuid(), decimals: 18, batches: [] } : null,
        };
    }
    async reportAccrualMintSubmitted(companyId, shareClassId, claimId, batchIndex, txHash) {
        return {
            status: true,
            message: "Mint batch submitted",
            payload: companyId && shareClassId && claimId ? { batchIndex, txHash } : null,
        };
    }
    async reportAccrualMintOutcome(companyId, shareClassId, claimId, batchIndex, txHash) {
        return {
            status: true,
            message: "Mint batch recorded",
            payload: companyId && shareClassId && claimId && txHash ? { batchIndex, result: "settled", movements: 0 } : null,
        };
    }
    async releaseAccrualMint(companyId, shareClassId, claimId) {
        return { status: true, message: "Mint released", payload: companyId && shareClassId && claimId ? {} : null };
    }
    async settleOpeningMintAccruals(companyId, shareClassId, movementIds) {
        return {
            status: true,
            message: "Opening mint accruals recorded",
            payload: companyId && shareClassId
                ? { settled: movementIds.length, units: "0.000000", investors: 0, uncovered: [] }
                : null,
        };
    }
    async getAccruedUnitsAsAt(companyId, shareholderId, shareClassId, asAt) {
        const rate = this.accrualRates[`${companyId}:${shareClassId}`]?.current?.annualRate ?? null;
        return {
            status: true,
            message: "Accrued units retrieved",
            payload: shareholderId
                ? { asAt, balance: "0.000000", unitsAccruedToDate: "0.000000", rateInEffect: rate, lastAccrualRecordedOn: null }
                : null,
        };
    }
    async getAccruedUnitsInWindow() {
        return { status: true, message: "Accrued units retrieved", payload: { unitsAccrued: "0.000000", movements: [] } };
    }
    async getAccrualSettings(companyId) {
        const payload = this.accrualSettings[companyId] ?? { accrues: false, roundingMethod: mystake_common_sdk_1.RoundingMethod.ROUND_DOWN };
        return { status: true, message: "Accrual settings retrieved", payload };
    }
    /** Stands in for whatever turns a fund's accrual on; the API offers no way to. */
    seedAccrualSettings(companyId, settings) {
        this.accrualSettings[companyId] = settings;
    }
    async updateAccrualSettings(companyId, settings) {
        const stored = this.accrualSettings[companyId] ?? { accrues: false, roundingMethod: mystake_common_sdk_1.RoundingMethod.ROUND_DOWN };
        const saved = { ...stored, roundingMethod: settings.roundingMethod };
        this.accrualSettings[companyId] = saved;
        return { status: true, message: "Accrual settings updated", payload: saved };
    }
    async createShareClassRwaTokenWalletProofChallenge(companyId, shareClassId, ownerWalletAddress) {
        if (companyId && shareClassId && ownerWalletAddress) {
            return {
                status: true,
                payload: {
                    challengeId: "walletproofchallenges-stub-1",
                    message: [
                        "Tokeniser wallet proof",
                        "",
                        "You are proving control of the wallet that will receive on-chain owner and agent rights.",
                        "This is not a payment and does not deploy the token.",
                        "",
                        `Address: ${ownerWalletAddress.toLowerCase()}`,
                        "Action: share-class-rwa-token-deploy",
                        `Company: ${companyId}`,
                        `Share class: ${shareClassId}`,
                        "Nonce: stub-nonce",
                        "Expires: 2099-01-01T00:00:00.000Z",
                    ].join("\n"),
                    expiresAt: "2099-01-01T00:00:00.000Z",
                },
                message: "Wallet proof challenge issued",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Failed to issue wallet proof challenge",
        };
    }
    async deployShareClassRwaToken(companyId, shareClassId, ownerWalletAddress, _) {
        if (companyId && shareClassId && ownerWalletAddress) {
            return {
                status: true,
                payload: {
                    shareClassId,
                    rwaTokenContractAddress: "0x1234567890123456789012345678901234567890",
                    rwaTokenDecimals: 18,
                    rwaSuiteSalt: "trex:stub-suite-salt",
                },
                message: "RWA token deployed successfully",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Failed to deploy RWA token",
        };
    }
    async confirmShareClassIdentityStorageLink(_companyId, shareClassId) {
        return {
            status: true,
            payload: {
                shareClassId,
                rwaTokenContractAddress: "0x1234567890123456789012345678901234567890",
                rwaTokenDecimals: 18,
                rwaSuiteSalt: "trex:stub-suite-salt",
            },
            message: "Identity registry storage linked",
        };
    }
    async getAdminViewInfo(companyId) {
        if (companyId) {
            const roles = ["dir", "sec"];
            const roleCount = faker.random.number(2);
            const officeholderCount = faker.random.number(5);
            const activityTypes = Object.values(enums_1.ActivityType);
            const activitySubTypes = Object.values(enums_1.ActivitySubType);
            const officeholdersByRoles = [];
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < roleCount; i++) {
                const officeholders = [];
                // eslint-disable-next-line no-plusplus
                for (let j = 0; j < officeholderCount; j++) {
                    officeholders.push({
                        salutation: "Mr.",
                        familyName: faker.name.lastName(),
                        firstName: faker.name.firstName(),
                        secondName: "",
                        thirdName: "",
                        role: roles[i],
                        dateOfAppointment: faker.date.past(),
                    });
                }
                officeholdersByRoles.push({
                    _id: roles[i],
                    officeholders,
                });
            }
            return {
                status: true,
                message: "Admin view info",
                payload: {
                    _id: faker.random.uuid(),
                    name: faker.company.companyName(),
                    acn: faker.random.number({ min: 100000000, max: 1000000000 }).toString(),
                    abn: faker.random.number({ min: 10000000000, max: 100000000000 }).toString(),
                    registeredAddress: fakeAddress,
                    principalPlaceOfBusinessAddress: fakeAddress,
                    totalQuantityOfAllShareClasses: faker.random.number(),
                    enterpriseValue: faker.random.number(),
                    officeholdersByRoles,
                    shareClasses: [
                        {
                            name: "ORDINARY",
                            shareClassCode: "ORD",
                            totalQuantity: 20000,
                            totalPaid: 200404220,
                            totalUnpaid: 223494,
                            currentSharePrice: 200,
                            dateLastUpdated: faker.date.past(),
                        },
                    ],
                    topTenShareholders: [
                        {
                            _id: faker.random.uuid(),
                            legalEntityName: faker.company.companyName(),
                            totalSharesOwned: faker.random.number(),
                        },
                    ],
                    recentActivityLogs: [
                        {
                            _id: faker.random.uuid(),
                            companyId: faker.random.uuid(),
                            activityType: activityTypes[faker.random.number(activityTypes.length) - 1],
                            activitySubType: activitySubTypes[faker.random.number(activitySubTypes.length - 1)],
                            activityDescription: faker.random.words(20),
                            dateOfAction: faker.date.recent(),
                            actionedByUser: {
                                userId: faker.random.uuid(),
                                familyName: faker.name.lastName(),
                                firstName: faker.name.firstName(),
                                secondName: "",
                                thirdName: "",
                            },
                        },
                    ],
                    nominee: { fullName: "John Smith", email: "john@mail.com" },
                },
            };
        }
        return { status: false, message: "Invalid request", payload: null };
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async getCompanyInformationPageData(companyId) {
        const data = {
            acn: faker.random.number({ min: 100000000, max: 999999999 }).toString(),
            abn: faker.random.number({ min: 10000000000, max: 99999999999 }).toString(),
            name: faker.company.companyName(),
            registeredAddress: {
                careOf: "",
                line2: "1",
                street: faker.address.streetName(),
                locality: faker.address.city(),
                state: ["QLD", "VIC", "ACT", "NSW", "NT", "SA", "WA"][faker.random.number({ min: 0, max: 6 })],
                postcode: faker.random.number({ min: 1000, max: 9999 }).toString(),
                country: "AU",
            },
            principalPlaceOfBusinessAddress: {
                careOf: "",
                line2: "1",
                street: faker.address.streetName(),
                locality: faker.address.city(),
                state: ["QLD", "VIC", "ACT", "NSW", "NT", "SA", "WA"][faker.random.number({ min: 0, max: 6 })],
                postcode: faker.random.number({ min: 1000, max: 9999 }).toString(),
                country: "AU",
            },
            shareClasses: [],
            officeholders: [],
            primaryAdminEmail: faker.internet.email(),
            companyContactEmail: faker.internet.email(),
        };
        const index = faker.random.number({ min: 0, max: 1 });
        const shareClassInformation = {
            name: ["ORDINARY", "PREFERRED"][index],
            shareClassCode: ["ORD", "PREF"][index],
            pricePerShare: faker.random.number({ min: 100, max: 10000 }),
            effectiveFrom: (0, moment_1.default)(faker.date.recent(faker.random.number({ min: 1, max: 27 }))).toDate(),
        };
        data.shareClasses.push(shareClassInformation);
        const officeHoldersInformation = {
            roles: [
                {
                    role: ["Company Secretary", "Director"][faker.random.number({ min: 0, max: 1 })],
                    dateOfAppointment: (0, moment_1.default)(faker.date.recent(faker.random.number({ min: 1, max: 27 }))).toDate(),
                },
            ],
            firstName: faker.name.firstName(),
            secondName: faker.name.firstName(),
            thirdName: faker.name.firstName(),
            familyName: faker.name.lastName(),
        };
        data.officeholders.push(officeHoldersInformation);
        return faker.random.boolean()
            ? Promise.resolve({
                status: true,
                message: "",
                payload: data,
            })
            : // eslint-disable-next-line prefer-promise-reject-errors
                Promise.reject({
                    status: false,
                    message: "Unable to fetch share class information",
                    payload: null,
                });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async getAdminList(companyId) {
        const data = [
            {
                _id: faker.random.uuid(),
                userId: faker.random.uuid(),
                username: faker.random.uuid(),
                firstName: faker.name.firstName(),
                secondName: faker.name.firstName(),
                thirdName: faker.name.firstName(),
                familyName: faker.name.lastName(),
                email: faker.internet.email(),
                lastActivity: "",
                invitationSentDate: faker.date.past(),
            },
        ];
        return Promise.resolve({
            status: true,
            message: "",
            payload: data,
        });
    }
    async updateAdminWalletAddress(companyId, userId, walletAddress) {
        return Promise.resolve({
            status: true,
            message: "",
            payload: { userId, walletAddress },
        });
    }
    async addNewAdmin(companyId, addNewAdminRequestBody) {
        if (companyId && addNewAdminRequestBody) {
            return {
                status: true,
                payload: null,
                message: "Admin successfully invited",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Failed to invite new admin",
        };
    }
    async resendAdminInvite(companyId, adminUserId) {
        if (companyId && adminUserId) {
            return {
                status: true,
                payload: null,
                message: "Admin invitation re-sent successfully",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Failed to resend admin invitation",
        };
    }
    async removeAdmin(companyId, adminUserId) {
        if (companyId && adminUserId) {
            return {
                status: true,
                payload: null,
                message: "Admin deleted successfully",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Failed to remove admin",
        };
    }
    async getShareholders(companyId, keyword = "") {
        if (keyword && companyId) {
            const resultCount = faker.random.number({ min: 2, max: 20 });
            const data = Array.from({ length: resultCount }, () => ({
                _id: faker.random.uuid(),
                entityType: mystake_validator_public_1.EntityType.JOINT,
                abn: "",
                acn: "",
                legalEntityName: `Shareholder${resultCount}`,
                legalEntityAddresses: Array.from({ length: resultCount }, () => ({
                    street: faker.address.streetName(),
                    locality: faker.address.county(),
                    state: faker.address.state(),
                    postcode: faker.address.zipCode(),
                    country: faker.address.country(),
                })),
                contacts: Array.from({ length: resultCount }, () => ({
                    salutation: faker.name.prefix(),
                    familyName: faker.name.lastName(),
                    firstName: faker.name.firstName(),
                    email: faker.internet.email(),
                    iso2Code: faker.address.countryCode(),
                    dialCode: faker.address.countryCode(),
                    phoneNumber: faker.phone.phoneNumber(),
                })),
                holdings: Array.from({ length: resultCount }, () => ({
                    shareClassId: faker.random.uuid(),
                    shareClass: faker.random.word(),
                    pricePerShare: faker.random.number({ min: 10, max: 1000 }),
                    shares: faker.random.number({ min: 10, max: 1000 }),
                    totalPaid: faker.random.number({ min: 100, max: 10000 }),
                    totalUnpaid: faker.random.number({ min: 100, max: 10000 }),
                })),
            }));
            return {
                status: true,
                payload: data,
                message: "",
            };
        }
        return {
            status: true,
            payload: [],
            message: "",
        };
    }
    async getShareholdersV2(companyId, keyword = "") {
        if (keyword && companyId) {
            return {
                status: true,
                payload: [],
                message: "",
            };
        }
        return {
            status: true,
            payload: [],
            message: "",
        };
    }
    async getShareholdersByTypeAndShareClass(companyId, keyword, shareClassId, investorTypes, sortBy, sortOrder, page, rowsPerPage, sharesInputType, maxSharesTradable, deniedShareholders, activeStatus, auctionShareholderIds) {
        if (keyword &&
            companyId &&
            shareClassId &&
            investorTypes &&
            sortBy &&
            sortOrder &&
            page &&
            rowsPerPage &&
            sharesInputType &&
            maxSharesTradable &&
            deniedShareholders &&
            activeStatus &&
            auctionShareholderIds) {
            return {
                status: true,
                payload: {
                    shareholders: [],
                    count: 0,
                    allShareholders: [],
                },
                message: "",
            };
        }
        return {
            status: true,
            payload: {
                shareholders: [],
                count: 0,
                allShareholders: [],
            },
            message: "",
        };
    }
    async getShareholder(companyId, shareholderId) {
        if (shareholderId && companyId) {
            return {
                status: true,
                payload: {},
                message: "",
            };
        }
        return {
            status: true,
            payload: {},
            message: "",
        };
    }
    async issueSharesToExistingShareholder(companyId, shareholderId, payload) {
        if (shareholderId && companyId && payload.transaction) {
            return {
                status: true,
                payload: null,
                message: "Success",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Failed to delete the admin",
        };
    }
    async updateRegisteredAddress(companyId, newRegisteredAddressData, authorisingOfficer) {
        if (companyId && newRegisteredAddressData && authorisingOfficer) {
            return faker.random.boolean();
        }
        return false;
    }
    async updatePrincipalPlaceOfBusinessAddress(companyId, newPrincipalPlaceOfBusinessAddressData, authorisingOfficer) {
        if (companyId && newPrincipalPlaceOfBusinessAddressData && authorisingOfficer) {
            return faker.random.boolean();
        }
        return false;
    }
    async importCSV(companyId, csvFile, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _options) {
        if (companyId && csvFile) {
            return {
                status: false,
                message: "Failed to process CSV",
                payload: {
                    errorCount: faker.random.number(),
                    errorText: faker.random.words(),
                },
            };
        }
        return { status: false, message: "Invalid request", payload: null };
    }
    async getInvestorInvitations(companyId, keyword, page, rowsPerPage, sortOrder) {
        if (companyId && keyword && page && rowsPerPage && sortOrder) {
            const allContactIds = [];
            const investorDetails = Array.from({
                length: 30,
            }).map(() => {
                const result = generateFakeInvestorDetails();
                allContactIds.push(result.contact._id);
                return result;
            });
            return {
                status: true,
                payload: { investorDetails, count: 30, allContactIds },
                message: "",
            };
        }
        return {
            status: false,
            payload: null,
            message: "",
        };
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async activateAsicConnection(companyId) {
        return {
            status: true,
            payload: null,
            message: "Asic connection activated",
        };
    }
    async getAsicConnectionStatus(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    companyId) {
        return {
            isAsicConnectionActivated: faker.random.boolean(),
            isAgentAuthorized: faker.random.boolean(),
        };
    }
    async getCas360ConnectionStatus(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    companyId) {
        return {
            status: "connected",
            lastImportError: "",
        };
    }
    async getBgl360AuthoriseUrl(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    companyId) {
        return {
            status: true,
            payload: "https://www.google.com",
            message: "Success",
        };
    }
    async bglResync(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    companyId) {
        return {
            status: true,
            payload: null,
            message: "Success",
        };
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async updateAsicData(companyId, adminUserId) {
        return {
            status: true,
            payload: null,
            message: "Asic data updated",
        };
    }
    async generateHoldingStatement(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    companyId, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    shareholderId, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    startDate, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    endDate) {
        return {
            status: true,
            payload: null,
            message: "Success",
        };
    }
    async generateAccrualStatement() {
        return { status: true, message: "Accrual statement generated", payload: "" };
    }
    async getCompanyPlanInfo(companyId) {
        if (companyId) {
            const pricePlanInfo = {
                id: `price_${faker.random.alphaNumeric()}`,
                productId: `product_${faker.random.alphaNumeric()}`,
                productName: faker.random.word(),
                recurringInterval: "month",
                recurringIntervalCount: 1,
                trialPeriodDays: faker.random.number(30),
                amount: faker.random.number(),
                type: "recurring",
            };
            return {
                status: true,
                message: "Company Plan Info",
                payload: pricePlanInfo,
            };
        }
        return {
            status: false,
            message: "Failed to fetch company plan info",
            payload: null,
        };
    }
    async inviteNewShareholder(companyId, inviteNewShareholderRequestBody) {
        if (companyId && inviteNewShareholderRequestBody) {
            return {
                status: true,
                payload: null,
                message: "shareholder successfully invited",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Failed to invite new shareholder",
        };
    }
    async inviteOwnerContact(companyId, shareholderId, ownerIndex) {
        if (companyId && shareholderId && ownerIndex >= 0) {
            return {
                status: true,
                payload: null,
                message: "owner contact successfully invited",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Failed to invite owner contact",
        };
    }
    async inviteInvestorByDetails(companyId, inviteInvestorByDetailsRequestBody) {
        if (companyId && inviteInvestorByDetailsRequestBody) {
            return {
                status: true,
                payload: null,
                message: "Successfully sent invitation to investor",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Failed to send investor invitation",
        };
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async getStripeCustomerPortalUrl(companyId, returnPage) {
        if (companyId) {
            return Promise.resolve({
                status: false,
                message: "Stripe customer portal url",
                payload: "https://www.stripe.com",
            });
        }
        return Promise.reject(new Error("Failed to get Stripe Customer Portal URL"));
    }
    async getActivityLogs(companyId, sortBy, sortOrder, skip, limit) {
        if (companyId && sortBy && sortOrder && skip && limit) {
            const totalRecordsCount = faker.random.number(10);
            const activityLogs = [];
            const activityTypes = Object.values(enums_1.ActivityType);
            const activitySubTypes = Object.values(enums_1.ActivitySubType);
            for (let index = 0; index < totalRecordsCount; index += 1) {
                activityLogs.push({
                    _id: faker.random.uuid(),
                    companyId: faker.random.uuid(),
                    activityType: activityTypes[faker.random.number(activityTypes.length) - 1],
                    activitySubType: activitySubTypes[faker.random.number(activitySubTypes.length - 1)],
                    activityDescription: faker.random.words(20),
                    dateOfAction: faker.date.recent(),
                    actionedByUser: {
                        userId: faker.random.uuid(),
                        familyName: faker.name.lastName(),
                        firstName: faker.name.firstName(),
                        secondName: "",
                        thirdName: "",
                    },
                });
            }
            return {
                status: true,
                message: "Company Activity Logs",
                payload: { count: activityLogs.length, activityLogs },
            };
        }
        return {
            status: false,
            message: "Failed to fetch activity logs",
            payload: null,
        };
    }
    async getInvestorContacts(companyId, keyword, page, rowsPerPage, sortOrder, sortBy) {
        if (companyId && keyword && page && rowsPerPage && sortOrder && sortBy) {
            const allContactIds = [];
            const shareholderContactDetails = Array.from({
                length: 30,
            }).map(() => {
                const result = generateFakeContactDetails();
                allContactIds.push(result.contact._id);
                return result;
            });
            const noteholderContactDetails = Array.from({
                length: 15,
            }).map(() => {
                const result = generateFakeContactDetails();
                allContactIds.push(result.contact._id);
                return result;
            });
            const optionholderContactDetails = Array.from({
                length: 3,
            }).map(() => {
                const result = generateFakeContactDetails();
                allContactIds.push(result.contact._id);
                return result;
            });
            const contactDetails = [...shareholderContactDetails, ...noteholderContactDetails, ...optionholderContactDetails];
            return {
                status: true,
                payload: {
                    contactDetails,
                    shareholderContactDetails,
                    noteholderContactDetails,
                    optionholderContactDetails,
                    count: 48,
                    allContactIds,
                },
                message: "",
            };
        }
        return {
            status: false,
            payload: null,
            message: "",
        };
    }
    async getAllContacts(companyId) {
        if (companyId) {
            return {
                status: true,
                payload: [],
                message: "",
            };
        }
        return {
            status: false,
            payload: null,
            message: "",
        };
    }
    async createAnnouncement(companyId, createAnnouncementRequestBody) {
        if (companyId && createAnnouncementRequestBody) {
            return {
                status: true,
                payload: null,
                message: "Successfully sent email announcement",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Failed to send email announcement",
        };
    }
    async uploadDocument(companyId, uploadedByUserId, pdfFile, shareholderId, expiryDate, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    documentType) {
        if (companyId && pdfFile && uploadedByUserId && shareholderId && expiryDate) {
            return {
                status: true,
                message: "Document imported successfully",
                payload: null,
            };
        }
        return { status: false, message: "Failed import document", payload: null };
    }
    async deleteDocument(companyId, documentId) {
        if (companyId && documentId) {
            return {
                status: true,
                message: "Document deleted successfully",
                payload: null,
            };
        }
        return { status: false, message: "Failed to delete document", payload: null };
    }
    async getInvestorApplicationDocuments(companyId) {
        if (companyId) {
            return {
                status: true,
                message: "Success",
                payload: [],
            };
        }
        return { status: false, message: "Invalid request", payload: null };
    }
    async getCompanyDocuments(companyId, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    page, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    rowsPerPage, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sortBy, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sortOrder) {
        if (companyId) {
            const documentList = [
                {
                    _id: faker.random.uuid(),
                    fileName: faker.random.word(),
                    dateUploaded: faker.date.past(),
                    uploadedByUser: {
                        userId: faker.random.uuid(),
                        firstName: faker.name.firstName(),
                        familyName: faker.name.lastName(),
                    },
                },
            ];
            return {
                status: false,
                message: "Success",
                payload: { documentList, count: 1 },
            };
        }
        return { status: false, message: "Invalid request", payload: null };
    }
    async getShareholderDocuments(companyId, shareholderId) {
        if (companyId && shareholderId) {
            return {
                status: true,
                message: "Success",
                payload: [
                    {
                        _id: faker.random.uuid(),
                        fileName: faker.random.word(),
                        expiryDate: faker.date.future(),
                    },
                ],
            };
        }
        return { status: false, message: "Failed", payload: null };
    }
    async getAdminOnlyShareholderDocuments(companyId, shareholderId) {
        if (companyId && shareholderId) {
            return {
                status: true,
                message: "Success",
                payload: [
                    {
                        _id: faker.random.uuid(),
                        fileName: faker.random.word(),
                        dateUploaded: faker.date.past(),
                    },
                ],
            };
        }
        return { status: false, message: "Failed", payload: null };
    }
    async uploadAdminOnlyDocument(companyId, uploadedByUserId, pdfFile, shareholderId) {
        if (companyId && uploadedByUserId && pdfFile && shareholderId) {
            return {
                status: true,
                message: "Document uploaded successfully",
                payload: { errorText: "" },
            };
        }
        return { status: false, message: "Failed", payload: null };
    }
    async deleteAdminOnlyDocument(companyId, documentId) {
        if (companyId && documentId) {
            return {
                status: true,
                message: "Document deleted successfully",
                payload: null,
            };
        }
        return { status: false, message: "Failed", payload: null };
    }
    async getSignedUrlOfDocument(companyId, documentId) {
        if (companyId && documentId) {
            return {
                status: true,
                message: "Success",
                payload: faker.internet.url(),
            };
        }
        return { status: false, message: "Failed", payload: null };
    }
    async uploadCompanyLogo(companyId, logoFile) {
        if (companyId && logoFile) {
            return {
                status: true,
                message: "Company logo uploaded successfully",
                payload: null,
            };
        }
        return {
            status: false,
            message: "Failed to upload company logo",
            payload: null,
        };
    }
    async setCompanyDisplayName(companyId, name) {
        if (companyId && name) {
            return {
                status: true,
                message: "Company display name updated successfully",
                payload: null,
            };
        }
        return {
            status: false,
            message: "Failed to update company display name",
            payload: null,
        };
    }
    async getDistributionSettings(companyId) {
        if (companyId) {
            return {
                status: true,
                message: "Distribution settings retrieved",
                payload: {
                    allowReinvestment: true,
                    roundingMethod: mystake_common_sdk_1.RoundingMethod.ROUND_DOWN,
                    apcaId: "123456",
                    taxResidencyCountryCode: "AUS",
                    investorTreatment: mystake_common_sdk_1.InvestorTreatment.AUTO,
                },
            };
        }
        return {
            status: false,
            message: "Failed to retrieve distribution settings",
            payload: null,
        };
    }
    async updateDistributionSettings(companyId, config) {
        if (companyId && config) {
            return {
                status: true,
                message: "Distribution settings updated",
                payload: config,
            };
        }
        return {
            status: false,
            message: "Failed to update distribution settings",
            payload: null,
        };
    }
    async getBankAccounts(companyId) {
        if (companyId) {
            return {
                status: true,
                message: "Bank accounts retrieved",
                payload: {
                    accounts: [
                        {
                            purpose: "subscription",
                            label: "Subscription payments received",
                            accountName: "Stub Fund",
                            bsb: "062-123",
                            accountNumber: "123456",
                            additionalFields: {},
                            isComplete: true,
                            missingFields: [],
                            divergences: [],
                        },
                        {
                            purpose: "distributionSettlement",
                            label: "Distribution settlement payments sent",
                            bsb: "062-123",
                            accountNumber: "123456",
                            additionalFields: { fiCode: "AB", apcaId: "654321" },
                            isComplete: true,
                            missingFields: [],
                            isLinked: false,
                        },
                    ],
                },
            };
        }
        return {
            status: false,
            message: "Failed to retrieve bank accounts",
            payload: null,
        };
    }
    async updateBankAccounts(companyId, update) {
        if (companyId) {
            const isLinked = "linkedToSubscriptionAccount" in update ? update.linkedToSubscriptionAccount : false;
            return {
                status: true,
                message: "Bank accounts updated",
                payload: {
                    accounts: [
                        {
                            purpose: "subscription",
                            label: "Subscription payments received",
                            accountName: "Stub Fund",
                            bsb: "062-123",
                            accountNumber: "123456",
                            additionalFields: {},
                            isComplete: true,
                            missingFields: [],
                            divergences: [],
                        },
                        {
                            purpose: "distributionSettlement",
                            label: "Distribution settlement payments sent",
                            bsb: "062-123",
                            accountNumber: "123456",
                            additionalFields: { fiCode: "AB", apcaId: "654321" },
                            isComplete: true,
                            missingFields: [],
                            isLinked,
                        },
                    ],
                },
            };
        }
        return {
            status: false,
            message: "Failed to update bank accounts",
            payload: null,
        };
    }
    async getActivityNotificationConfig(companyId) {
        if (companyId) {
            return {
                status: true,
                message: "Activity notification settings retrieved",
                payload: { recipientEmails: ["ops@example.com"] },
            };
        }
        return {
            status: false,
            message: "Failed to retrieve activity notification settings",
            payload: null,
        };
    }
    async getInvestorApplicationConfig(companyId) {
        if (companyId) {
            return { status: true, message: "", payload: { expectedDocuments: null } };
        }
        return { status: false, message: "Failed to load investor application settings", payload: null };
    }
    async updateInvestorApplicationConfig(companyId, config) {
        if (companyId) {
            return { status: true, message: "", payload: { expectedDocuments: config.expectedDocuments ?? null } };
        }
        return { status: false, message: "Failed to save investor application settings", payload: null };
    }
    async updateWholesaleVerification(companyId, shareholderId, verification) {
        if (companyId && shareholderId) {
            return {
                status: true,
                message: "Wholesale verification updated",
                payload: { wholesaleVerification: verification },
            };
        }
        return { status: false, message: "Failed to update wholesale verification", payload: null };
    }
    async updateActivityNotificationConfig(companyId, config) {
        if (companyId && config) {
            return {
                status: true,
                message: "Activity notification settings updated",
                payload: config,
            };
        }
        return {
            status: false,
            message: "Failed to update activity notification settings",
            payload: null,
        };
    }
    async updateProtocolSettings(companyId, settings) {
        if (companyId && settings) {
            return {
                status: true,
                message: "Protocol settings updated",
                payload: settings,
            };
        }
        return {
            status: false,
            message: "Failed to update protocol settings",
            payload: null,
        };
    }
    async listApiCredentials(companyId) {
        if (companyId) {
            return {
                status: true,
                message: "API credentials retrieved",
                payload: {
                    items: [
                        {
                            maskToken: "ab............yz",
                            credentialId: "550e8400-e29b-41d4-a716-446655440000",
                            createdAt: "2026-07-01T12:00:00.000Z",
                            revokedAt: null,
                        },
                    ],
                },
            };
        }
        return {
            status: false,
            message: "Failed to retrieve API credentials",
            payload: null,
        };
    }
    async registerApiCredential(companyId) {
        if (companyId) {
            return {
                status: true,
                message: "API credential registered",
                payload: {
                    apiKey: "stub-api-key",
                    signingSecret: "stub-signing-secret",
                    credential: {
                        maskToken: "st............ub",
                        credentialId: "550e8400-e29b-41d4-a716-446655440000",
                        createdAt: "2026-07-01T12:00:00.000Z",
                        revokedAt: null,
                    },
                },
            };
        }
        return {
            status: false,
            message: "Failed to register API credential",
            payload: null,
        };
    }
    async revokeApiCredential(companyId, credentialId) {
        if (companyId && credentialId) {
            return {
                status: true,
                message: "API credential revoked",
                payload: {
                    maskToken: "st............ub",
                    credentialId,
                    createdAt: "2026-07-01T12:00:00.000Z",
                    revokedAt: "2026-07-23T01:30:00.000Z",
                },
            };
        }
        return {
            status: false,
            message: "Failed to revoke API credential",
            payload: null,
        };
    }
    async getUnitTransferStatement(_companyId, _shareholderId, _transferId, _) {
        if (_companyId && _shareholderId && _transferId) {
            return {
                status: true,
                message: "Unit Transfer Notice generated",
                payload: "stub-pdf-base64",
            };
        }
        return {
            status: false,
            message: "Failed to generate Unit Transfer Notice",
            payload: null,
        };
    }
    async deleteTransactionsOfShareholder(companyId, shareholderIds) {
        if (companyId && shareholderIds) {
            return {
                status: true,
                message: "Success",
                payload: null,
            };
        }
        return {
            status: true,
            message: "Failed",
            payload: null,
        };
    }
    async deleteTransactionsOfACompany(companyId) {
        if (companyId) {
            return {
                status: true,
                message: "Success",
                payload: null,
            };
        }
        return {
            status: true,
            message: "Failed",
            payload: null,
        };
    }
    async getOfficeholders(companyId) {
        if (companyId) {
            return {
                status: true,
                message: "Success",
                payload: {
                    DIR: [
                        {
                            _id: "officeholder-id-1",
                            companyId: "id-213",
                            name: { firstName: "First name", familyName: "Family name" },
                            roles: [{ dateOfAppointment: new Date(), role: "dir" }],
                        },
                    ],
                    SEC: [
                        {
                            _id: "officeholder-id-2",
                            companyId: "id-213",
                            name: { firstName: "First name", familyName: "Family name" },
                            roles: [{ dateOfAppointment: new Date(), role: "dir" }],
                        },
                    ],
                },
            };
        }
        return {
            status: false,
            message: "Success",
            payload: {
                DIR: [
                    {
                        _id: "officeholder-id-1",
                        companyId: "id-213",
                        name: { firstName: "First name", familyName: "Family name" },
                        roles: [{ dateOfAppointment: new Date(), role: "dir" }],
                    },
                ],
                SEC: [
                    {
                        _id: "officeholder-id-2",
                        companyId: "id-213",
                        name: { firstName: "First name", familyName: "Family name" },
                        roles: [{ dateOfAppointment: new Date(), role: "dir" }],
                    },
                ],
            },
        };
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async getOfficeholderById(companyId, officeholderId) {
        return {
            status: true,
            message: "Success",
            payload: {
                _id: "officeholder-id-1",
                companyId: "id-213",
                name: { firstName: "First name", familyName: "Family name" },
                roles: [{ dateOfAppointment: new Date(), role: "dir" }],
            },
        };
    }
    async removeOfficeholders(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    companyId, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    removeOfficeholdersRequestBody) {
        return {
            status: true,
            message: "Success",
            payload: null,
        };
    }
    async appointOfficeholder(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    companyId, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    appointOfficeholderRequestBody) {
        return {
            status: true,
            message: "Success",
            payload: null,
        };
    }
    async updateOfficeholder(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    companyId, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    officeholderId, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    editOfficeholderRequestBody) {
        return {
            status: true,
            message: "Success",
            payload: null,
        };
    }
    async createNewNotes(companyId, createNotesData) {
        if (companyId && createNotesData) {
            return {
                status: true,
                payload: null,
                message: "New Notes created successfully",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Error creating new Note",
        };
    }
    async getAllNotes(companyId) {
        if (companyId) {
            const fakeNotesData = [generateFakeNotesData()];
            return {
                status: true,
                message: "Success",
                payload: fakeNotesData,
            };
        }
        return {
            status: false,
            payload: null,
            message: "Error getting notes list",
        };
    }
    async issueNotesToExistingShareholder(companyId, shareholderId, transaction) {
        if (shareholderId && companyId && transaction) {
            return {
                status: true,
                payload: null,
                message: "Success",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Failed to issue note",
        };
    }
    async issueNotesToNewShareholder(companyId, shareholder) {
        if (shareholder && companyId) {
            return {
                status: true,
                payload: { shareholderId: faker.random.uuid() },
                message: "Successfully issued note to new shareholder",
            };
        }
        return {
            status: false,
            payload: null,
            message: "",
        };
    }
    async getNotesRegister(companyId, keyword, activeClassId, page, rowsPerPage, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sortBy, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sortOrder) {
        const count = faker.random.number({ min: 150, max: 280 });
        const tabCount = faker.random.number({ min: 1, max: 2 });
        const data = [];
        for (let i = 0; i < (rowsPerPage < count ? rowsPerPage : count); i += 1) {
            data.push({
                _id: faker.random.uuid(),
                notesCode: ["CS1", "CN1"],
                legalEntityName: `${faker.name.prefix()} ${faker.name.firstName()} ${faker.name.lastName()}`,
                dateOfFirstIssue: faker.date.past().toISOString(),
                totalAmountInvested: faker.random.number(),
            });
        }
        return {
            status: false,
            payload: {
                codes: tabCount === 1
                    ? [{ _id: faker.random.uuid(), code: "CN1" }]
                    : [
                        { _id: faker.random.uuid(), code: "CN1" },
                        { _id: faker.random.uuid(), code: "CN2" },
                    ],
                count,
                data,
            },
            message: "",
        };
    }
    async getExpiringKycRegister(companyId, keyword, page, rowsPerPage, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sortBy, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sortOrder) {
        const count = faker.random.number({ min: 0, max: 12 });
        const data = [];
        for (let i = 0; i < (rowsPerPage < count ? rowsPerPage : count); i += 1) {
            data.push({
                _id: faker.random.uuid(),
                legalEntityName: `${faker.name.firstName()} ${faker.name.lastName()}`,
                kycExpiryDate: faker.random.boolean() ? faker.date.future() : null,
                email: faker.internet.email(),
            });
        }
        return {
            status: true,
            payload: { count, data },
            message: "",
        };
    }
    async getNotesCsvData(companyId) {
        if (companyId) {
            return {
                status: true,
                payload: [],
                message: "",
            };
        }
        return {
            status: false,
            payload: null,
            message: "",
        };
    }
    async deleteNote(companyId, notesId) {
        if (companyId && notesId) {
            return {
                status: true,
                payload: null,
                message: "Note deleted successfully",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Failed to remove note",
        };
    }
    async getNotesNamesAndCodes(companyId) {
        if (companyId) {
            return {
                status: true,
                payload: [{ name: "Convertible Employee", code: "CNN1" }],
                message: "Successfully received note names and codes",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Failed to get note names and codes",
        };
    }
    async getOptionGrantDetailsByShareholderId(companyId, shareholderId, optiongrantId, entityType, trusteeType) {
        if (shareholderId && companyId) {
            const shareHolding = {
                entityDetail: {
                    entityType,
                    entities: [],
                },
                grantSummary: {
                    grantDate: new Date("2021-10-30T14:00:00.000+00:00"),
                    shareClassCode: ["ORD", "EMP", "TAX"][faker.random.number({ min: 0, max: 2 })],
                    exercisePrice: 260,
                    numberGranted: faker.random.number(10000),
                    numberVested: faker.random.number(1000),
                    numberScheduledToVest: faker.random.number(0),
                    numberExercised: 0,
                    vestingType: ["Time", "Manual"][faker.random.number({ min: 0, max: 1 })],
                    vestingPeriod: faker.random.number(60),
                    cliff: faker.random.number(12),
                    cliffAmount: faker.random.number(2000),
                    vestingFrequency: faker.random.number(10),
                    lastExerciseDate: new Date("2023-12-30T14:00:00.000+00:00"),
                    lastVestingDate: new Date("2023-10-30T14:00:00.000+00:00"),
                },
            };
            if (entityType === mystake_validator_public_1.EntityType.JOINT) {
                shareHolding.entityDetail.entities = Array.from({
                    length: 3,
                }).map(() => generateIndividualShareholder());
            }
            else if (entityType === mystake_validator_public_1.EntityType.COMPANY) {
                shareHolding.entityDetail = {
                    legalEntityName: faker.name.title(),
                    entityType,
                    entities: [
                        {
                            acn: faker.random.number().toString(),
                            contact: `${faker.name.firstName()} ${faker.name.lastName()}`,
                            ...generateEntityData(),
                        },
                    ],
                };
            }
            else if (entityType === mystake_validator_public_1.EntityType.TRUST || entityType === mystake_validator_public_1.EntityType.SMSF) {
                if (trusteeType === mystake_validator_public_1.TrusteeType.COMPANY) {
                    shareHolding.entityDetail = {
                        legalEntityName: faker.name.title(),
                        entityType,
                        entities: [
                            {
                                trustAbn: faker.random.number().toString(),
                                trusteeAcn: faker.random.number().toString(),
                                contact: `${faker.name.firstName()} ${faker.name.lastName()}`,
                                ...generateEntityData(),
                            },
                        ],
                    };
                }
                else if (trusteeType === mystake_validator_public_1.TrusteeType.INDIVIDUAL) {
                    shareHolding.entityDetail = {
                        legalEntityName: faker.name.title(),
                        entityType,
                        entities: Array.from({
                            length: 3,
                        }).map(() => generateIndividualTrustee()),
                    };
                }
            }
            else {
                shareHolding.entityDetail.entities = Array.from({
                    length: 1,
                }).map(() => generateIndividualShareholder());
            }
            return {
                status: true,
                payload: shareHolding,
                message: "",
            };
        }
        return {
            status: false,
            payload: null,
            message: "",
        };
    }
    async getOptionUnitsDetailsByGrantId(companyId, shareholderId, optiongrantId) {
        if (shareholderId && companyId && optiongrantId) {
            return {
                status: true,
                payload: [
                    {
                        _id: "123",
                        vestingDate: new Date("2020-10-10T14:00:00.000+00:00"),
                        numberGranted: faker.random.number(1000),
                        firstExercisedDate: new Date("2021-05-16T14:00:00.000+00:00"),
                        numberExercised: faker.random.number(1000),
                    },
                    {
                        _id: "345",
                        vestingDate: new Date("2021-10-10T14:00:00.000+00:00"),
                        numberGranted: 625,
                        numberExercised: 0,
                    },
                ],
                message: "",
            };
        }
        return {
            status: false,
            payload: null,
            message: "",
        };
    }
    // eslint-disable-next-line consistent-return
    async getNoteDetailsByShareholderId(companyId, shareholderId, notetransactionId, entityType, trusteeType) {
        if (shareholderId && companyId && notetransactionId) {
            const noteHolding = {
                entityDetails: {
                    entityType,
                    entities: [],
                },
                noteDetails: generateFakeNotesData(),
            };
            if (entityType === mystake_validator_public_1.EntityType.JOINT) {
                noteHolding.entityDetails.entities = Array.from({
                    length: 3,
                }).map(() => generateIndividualShareholder());
            }
            else if (entityType === mystake_validator_public_1.EntityType.COMPANY) {
                noteHolding.entityDetails = {
                    legalEntityName: faker.name.title(),
                    entityType,
                    entities: [
                        {
                            acn: faker.random.number().toString(),
                            contact: `${faker.name.firstName()} ${faker.name.lastName()}`,
                            ...generateEntityData(),
                        },
                    ],
                };
            }
            else if (entityType === mystake_validator_public_1.EntityType.TRUST || entityType === mystake_validator_public_1.EntityType.SMSF) {
                if (trusteeType === mystake_validator_public_1.TrusteeType.COMPANY) {
                    noteHolding.entityDetails = {
                        legalEntityName: faker.name.title(),
                        entityType,
                        entities: [
                            {
                                trustAbn: faker.random.number().toString(),
                                trusteeAcn: faker.random.number().toString(),
                                contact: `${faker.name.firstName()} ${faker.name.lastName()}`,
                                ...generateEntityData(),
                            },
                        ],
                    };
                }
                else if (trusteeType === mystake_validator_public_1.TrusteeType.INDIVIDUAL) {
                    noteHolding.entityDetails = {
                        legalEntityName: faker.name.title(),
                        entityType,
                        entities: Array.from({
                            length: 3,
                        }).map(() => generateIndividualTrustee()),
                    };
                }
            }
            else {
                noteHolding.entityDetails.entities = Array.from({
                    length: 1,
                }).map(() => generateIndividualShareholder());
            }
            return {
                status: true,
                payload: noteHolding,
                message: "",
            };
        }
    }
    async createNewOptionsPool(companyId, createNewOptionsPoolData) {
        if (createNewOptionsPoolData && companyId) {
            return {
                status: true,
                payload: null,
                message: "New Options pool created successfully",
            };
        }
        return {
            status: false,
            payload: null,
            message: "",
        };
    }
    async convertNotes(companyId, shareholderId, notesId, transaction) {
        if (companyId && shareholderId && notesId && transaction) {
            return {
                status: true,
                payload: null,
                message: "Successfully converted note",
            };
        }
        return {
            status: false,
            payload: null,
            message: "",
        };
    }
    async updateOptionsPool(companyId, optionsPoolId, updateOptionsPoolData) {
        if (updateOptionsPoolData && companyId && optionsPoolId) {
            return {
                status: true,
                payload: null,
                message: "New Options pool updated successfully",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Error updating options pool",
        };
    }
    async removeOptionsPool(companyId, optionsPoolId) {
        if (companyId && optionsPoolId) {
            return {
                status: true,
                payload: null,
                message: "Options pool deleted successfully",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Error deleting options pool",
        };
    }
    async getOptionPoolNames(companyId, type) {
        const numberOfPools = type === OptionGrantType_1.OptionGrantsType.EMPLOYEE ? 4 : 8;
        const fakeData = Array(numberOfPools).map(() => ({
            _id: faker.random.uuid(),
            name: faker.random.word(),
            code: ["OPT1", "OPT2"][faker.random.number({ min: 0, max: 1 })],
            shareClass: {
                _id: faker.random.uuid(),
                name: faker.random.word(),
                shareClassCode: faker.random.alphaNumeric(4),
                defaultExercisePrice: faker.random.number(20),
            },
        }));
        return {
            status: true,
            payload: fakeData,
            message: "Successfully retrieved option pool names",
        };
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async getOptionPools(companyId) {
        const fakeData = Array.from({ length: faker.random.number(6) }).map(() => ({
            optiongrantIds: [],
            _id: faker.random.uuid(),
            name: faker.random.word(),
            shareclassId: faker.random.uuid(),
            totalOptions: faker.random.number(1000000),
            createdAt: faker.date.past(),
            updatedAt: faker.date.past(),
            code: faker.random.alphaNumeric(4),
            data: {
                granted: faker.random.number(1000000),
                availableToGrant: faker.random.number(1000000),
                unvested: faker.random.number(1000000),
                vested: faker.random.number(1000000),
                exercised: faker.random.number(1000000),
            },
        }));
        return {
            status: true,
            payload: fakeData,
            message: "Successfully retrieved option pool names",
        };
    }
    async createNewOptionGrant(companyId, optionGrantData) {
        if (companyId && optionGrantData) {
            return {
                status: true,
                payload: { shareholderId: faker.random.uuid() },
                message: "Successfully created an option unit",
            };
        }
        return {
            status: false,
            payload: { shareholderId: faker.random.uuid() },
            message: "Failed to create an option unit",
        };
    }
    async deleteOptionUnit(companyId, optionUnitId) {
        if (companyId && optionUnitId) {
            return {
                status: true,
                payload: null,
                message: "The option unit was deleted successfully",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Failed to delete the option uni",
        };
    }
    async createOptionUnit(companyId, optionUnitData) {
        if (companyId && optionUnitData) {
            return {
                status: true,
                payload: null,
                message: "Successfully created an option unit",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Error creating an option unit",
        };
    }
    getOptionRegisterForOptionholder() {
        const fakeData = Array(faker.random.number(5)).map(() => ({
            _id: faker.random.uuid(),
            grantDate: faker.date.past(),
            shareClass: {
                _id: faker.random.uuid(),
                name: faker.random.word(),
                shareClassCode: faker.random.alphaNumeric(4),
            },
            exercisePrice: faker.random.number(25),
            numberOfOptions: faker.random.number(1000),
            vested: faker.random.number(200),
            exercised: faker.random.number(200),
            lastExerciseDate: faker.date.future(),
        }));
        return Promise.resolve({
            status: true,
            payload: fakeData,
            message: "Successfully retrieved option pool names",
        });
    }
    getOptionRegister() {
        const fakeData = Array(faker.random.number(6)).map(() => ({
            _id: faker.random.uuid(),
            legalEntityName: faker.random.word(),
            optionCode: ["CS1", "CN1"],
            totalGranted: faker.random.number(),
            totalVested: faker.random.number(),
            totalExercised: faker.random.number(),
            dateOfFirstGrant: faker.date.past(),
        }));
        const pools = Array(faker.random.number(5)).map(() => ({
            _id: faker.random.uuid(),
            name: faker.random.word(),
            code: faker.random.alphaNumeric(4),
        }));
        return Promise.resolve({
            status: true,
            payload: {
                pools,
                data: fakeData,
                count: faker.random.number(fakeData.length * 2),
            },
            message: "Successfully retrieved option pool names",
        });
    }
    async getOptionsCsvData() {
        const data = [];
        return {
            status: true,
            payload: data,
            message: "Successfully retrieved option csv data",
        };
    }
    async getOptionPoolNamesAndCodes(companyId) {
        if (companyId) {
            return {
                status: true,
                payload: [{ name: "Option pool 1", code: "OPN1" }],
                message: "Successfully received option pools names and codes",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Failed to get option pools names and codes",
        };
    }
    async exerciseOptions(companyId, optiongrantId, exerciseData) {
        if (companyId && optiongrantId && exerciseData) {
            return {
                status: true,
                payload: null,
                message: "Successfully exercised options",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Error exercising options",
        };
    }
    async updateGrant(companyId, optiongrantId, updateData) {
        if (companyId && optiongrantId && updateData) {
            return {
                status: true,
                payload: null,
                message: "Successfully updated option grant",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Error updating option grant",
        };
    }
    async deleteGrant(companyId, optiongrantId) {
        if (companyId && optiongrantId) {
            return {
                status: true,
                payload: null,
                message: "Successfully deleted option grant",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Error deleting option grant",
        };
    }
    async generateShareCertificate(companyId, shareholderId, shareCertificateId) {
        if (companyId && shareCertificateId && shareholderId) {
            return {
                status: true,
                payload: null,
                message: "Success",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Error creating certificate",
        };
    }
    async createNewFundraise(companyId, createFundraiseData) {
        if (companyId && createFundraiseData) {
            return {
                status: true,
                payload: null,
                message: "Fundraise round created successfully",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Error creating Fundraise round",
        };
    }
    async getFundraiseByFundraiseId(companyId, fundraiseId) {
        if (companyId && fundraiseId) {
            const fakeFundraiseData = generateFakeFundraiseData();
            return {
                status: true,
                message: "Successfully returned Fundraise round",
                payload: fakeFundraiseData[0],
            };
        }
        return {
            status: false,
            payload: null,
            message: "Error getting fundraise round",
        };
    }
    async paySubscriptionAgreement(companyId, paySubscriptionAgreementRequestBody) {
        if (companyId && paySubscriptionAgreementRequestBody) {
            return {
                status: true,
                payload: null,
                message: "Paymemt details successfully sent",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Failed send payment details",
        };
    }
    async generateReconciliationReport(companyId, fundraiseRound, timestamp) {
        if (companyId && fundraiseRound && timestamp) {
            return {
                status: true,
                payload: null,
                message: "Reconciliation report successfully generated",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Error generating reconciliation report",
        };
    }
    async getHighestShareCertificateNumber(companyId) {
        if (companyId) {
            return {
                status: true,
                payload: faker.random.number(),
                message: "succesfully returned highest certificate number",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Error returning highest certificate number",
        };
    }
    async getFundraiseCsvDataByFundraiseId(companyId, fundraiseId) {
        if (companyId && fundraiseId) {
            const data = [];
            const offerAmount = faker.random.number();
            const fees = offerAmount * 0.006;
            data.push({
                legalEntityName: `${faker.name.prefix()} ${faker.name.firstName()} ${faker.name.lastName()}`,
                bankReference: "FR00001",
                shareQuantity: faker.random.number(),
                offerAmount,
                paidDate: faker.date.past().toISOString(),
                fees,
                amountDeposited: offerAmount - fees,
                offerId: faker.random.uuid(),
            });
            return {
                status: true,
                payload: data,
                message: "Fundraise csv data found",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Error returning Fundraise csv data",
        };
    }
    async createFundraiseBankAccount(companyId, bankAccount) {
        if (bankAccount && companyId) {
            return {
                status: true,
                payload: null,
                message: "Fundraise bank account created successfully",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Error creating fundraise bank account",
        };
    }
    async ensureInvestorOnchainId(companyId, shareholderId) {
        if (companyId && shareholderId) {
            return {
                status: true,
                payload: { onchainId: "0x0000000000000000000000000000000000000001" },
                message: "Investor ONCHAINID saved",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Error saving investor ONCHAINID",
        };
    }
    async createInvestorOnchainIdWalletProofChallenge(companyId, ownerWalletAddress) {
        if (companyId && ownerWalletAddress) {
            return {
                status: true,
                payload: {
                    challengeId: "walletproofchallenges-stub-2",
                    message: `Tokeniser wallet proof\n\nAddress: ${ownerWalletAddress.toLowerCase()}`,
                    expiresAt: "2099-01-01T00:00:00.000Z",
                },
                message: "Wallet proof challenge issued",
            };
        }
        return { status: false, payload: null, message: "Error issuing wallet proof challenge" };
    }
    async ensureCompanyInvestorOnchainId(companyId, managerAddress, challengeId, signature) {
        if (companyId && managerAddress && challengeId && signature) {
            return {
                status: true,
                payload: { onchainId: "0x0000000000000000000000000000000000000001" },
                message: "Investor ONCHAINID saved",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Error saving investor ONCHAINID",
        };
    }
    async getVaultSetup(companyId) {
        if (companyId) {
            return {
                status: true,
                message: "Vault setup retrieved",
                payload: IVaultSetup_1.VAULT_SETUP_NOT_CONFIGURED,
            };
        }
        return {
            status: false,
            message: "Error retrieving vault setup",
            payload: null,
        };
    }
    createFundSet() {
        return Promise.resolve({
            status: false,
            message: "Vault setup is not configured on this deployment.",
            payload: null,
        });
    }
    async saveVaultSet(companyId, shareClassId, stablecoinAddress) {
        if (companyId && shareClassId && stablecoinAddress) {
            return {
                status: true,
                message: "Vault set saved",
                payload: {
                    vaultAddress: "0x0000000000000000000000000000000000000a01",
                    assetAddress: "0x0000000000000000000000000000000000000a02",
                    escrowAddress: "0x0000000000000000000000000000000000000a03",
                    navTrackerAddress: "0x0000000000000000000000000000000000000a04",
                    supplyControllerAddress: "0x0000000000000000000000000000000000000a05",
                },
            };
        }
        return {
            status: false,
            message: "Error saving vault set",
            payload: null,
        };
    }
    async recordVaultOperation(companyId, shareClassId, txHash, _) {
        return companyId && shareClassId && txHash
            ? { status: true, message: "Vault operation logged", payload: null }
            : { status: false, message: "Error logging the vault operation", payload: null };
    }
    async recordOwnershipTransfer(companyId, shareClassId, txHashes) {
        return companyId && shareClassId && txHashes.length
            ? { status: true, message: "Ownership transfer logged", payload: null }
            : { status: false, message: "Error logging the ownership transfer", payload: null };
    }
    async updateCompanyClaimIssuerOnchainId(companyId, onchainId) {
        if (companyId && onchainId) {
            return {
                status: true,
                payload: { onchainId: onchainId.toLowerCase() },
                message: "Company Claim Issuer ONCHAINID saved",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Error saving company Claim Issuer ONCHAINID",
        };
    }
    async getAllInvestors(companyId, keyword, page, rowsPerPage, sortBy, sortOrder, status = [mystake_common_sdk_1.ShareholderStatus.ACCEPTED]) {
        if (companyId && keyword && page && rowsPerPage && sortBy && sortOrder && status) {
            const data = {};
            return {
                status: true,
                payload: data,
                message: "Succesfully fetched investors data",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Failed to fetch investors data",
        };
    }
    async updateCompanyContactEmail(companyId, email) {
        if (companyId && email) {
            return {
                status: true,
                payload: null,
                message: "Company contact email updated successfully",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Error updating company contact email",
        };
    }
    async setLiquidityProvider(companyId, { shareholderId, }) {
        if (companyId && shareholderId) {
            return {
                status: true,
                payload: null,
                message: "Liquidity provider set successfully",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Error setting liquidity provider",
        };
    }
    async getLiquidityProvider(companyId) {
        if (companyId) {
            return {
                status: true,
                payload: null,
                message: "Succesfully fetched liquidity providers",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Error fetching liquidity providers",
        };
    }
    async requestActOnBehalf(companyId, shareholderId, contactId) {
        if (companyId && shareholderId && contactId) {
            return {
                status: true,
                payload: null,
                message: "Act on behalf request submitted successfully",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Error submitting act on behalf request",
        };
    }
    async approveActOnBehalf(companyId, shareholderId, contactId, kyc) {
        if (companyId && shareholderId && contactId && kyc.verificationDate) {
            return {
                status: true,
                payload: null,
                message: "Act on behalf request approved successfully",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Error approving act on behalf request",
        };
    }
    async declineActOnBehalf(companyId, shareholderId, contactId) {
        if (companyId && shareholderId && contactId) {
            return {
                status: true,
                payload: null,
                message: "Act on behalf request declined successfully",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Error declining act on behalf request",
        };
    }
    async revokeActOnBehalf(companyId, shareholderId, contactId) {
        if (companyId && shareholderId && contactId) {
            return {
                status: true,
                payload: null,
                message: "Act on behalf request revoked successfully",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Error revoking act on behalf request",
        };
    }
    async getActOnBehalfRequests(companyId, page, rowsPerPage) {
        if (companyId && page >= 0 && rowsPerPage > 0) {
            return {
                status: true,
                payload: {
                    rows: [],
                    count: 0,
                },
                message: "Act on behalf requests retrieved successfully",
            };
        }
        return {
            status: false,
            payload: {
                rows: [],
                count: 0,
            },
            message: "Error retrieving act on behalf requests",
        };
    }
    async getTrustees(companyId, shareholderId) {
        if (companyId && shareholderId) {
            return {
                status: true,
                payload: [stubTrustee(companyId, shareholderId)],
                message: "Trustees retrieved successfully",
            };
        }
        return {
            status: false,
            payload: [],
            message: "Error retrieving trustees",
        };
    }
    async inviteTrustee(companyId, shareholderId, trusteeId) {
        if (companyId && shareholderId && trusteeId) {
            return {
                status: true,
                payload: null,
                message: "Trustee successfully invited",
            };
        }
        return {
            status: false,
            payload: null,
            message: "Failed to invite trustee",
        };
    }
}
exports.CompanyServiceStub = CompanyServiceStub;
//# sourceMappingURL=CompanyServiceStub.js.map